import * as React from 'react';

const Bedroom = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={22} height={22} viewBox="0 0 22 22" {...props}>
        <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.3}>
            <path strokeWidth={1.191671} d="M.688 7.563 11 .688l10.313 6.875M2.063 17.188h17.875v4.125H2.063v-9.625" />
            <path
                strokeWidth={1.191671}
                d="M4.813 13.063h-2.75v4.124h5.5v-1.375a2.75 2.75 0 0 0-2.75-2.75M17.188 13.063h-4.326a4.13 4.13 0 0 0-3.69 2.28l-.922 1.845h11.688v-1.375a2.75 2.75 0 0 0-2.75-2.75"
            />
        </g>
    </svg>
);
export default Bedroom;
